<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
        <!-- Logo -->
        <div class="logo">
            <a routerLink="/"><img src="assets/img/logo.png" alt="Logo" /></a>
        </div>

        <!-- Mobile toggle button -->
        <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
            <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Nav items -->
        <div [ngClass]="{'collapse navbar-collapse': true, 'show': !isMenuCollapsed}" id="navbarSupportedContent">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a routerLink="/ueber-uns" class="nav-link">À propos</a>
                </li>
                <li class="nav-item">
                    <a routerLink="/team" class="nav-link">L’équipe</a>
                </li>
                <li class="nav-item">
                    <a routerLink="/spende" class="nav-link">Faire un don</a>
                </li>
                <li class="nav-item">
                    <a routerLink="/projects" class="nav-link">Projets</a>
                </li>
                <li class="nav-item">
                    <a routerLink="/blog" class="nav-link">Actualités</a>
                </li>
                <li class="nav-item">
                    <a routerLink="/rapports" class="nav-link">Rapports</a>
                </li>
                <li class="nav-item">
                    <a routerLink="/kontakt" class="nav-link">Contact</a>
                </li>
            </ul>

            <div class="others-option d-flex align-items-center">
                <a routerLink="/kontakt" class="default-btn">Nous contacter</a>
            </div>
        </div>
    </div>
</nav>
